import UIReducer from './UIReducer';
export default UIReducer;
